module.exports = __webpack_public_path__ + "img/Unidad19-1.c1ec6688.png";